import {
    ROUNDED_BUTTON_STYLE,
} from '@domain/integrations/integration-strategies/modal-strategy/modal-strategy.styles';


export const ButtonStyle = {
    ...ROUNDED_BUTTON_STYLE,
    marginTop: '8px',
};
